import { InLifeLayout } from '@in-life/components/Layout';
import { ThankYou } from '@in-life/features/ThankYou';

import { withProfiler } from '@services/sentry/withProfiler';

const ThankYouPageUnwrapped = () => {
  return (
    <InLifeLayout>
      <ThankYou />
    </InLifeLayout>
  );
};

const ThankYouPage = withProfiler(ThankYouPageUnwrapped);

export { ThankYouPage };
